/**
 * `wpp::table.bulk-actions-select`
 *
 * Drives the header checkbox's three states. `indeterminate` is a property, not
 * an attribute, so it cannot be set from markup at all — which is why this
 * needs to exist rather than being a class binding.
 *
 * @param {{ mode?: 'none'|'partial'|'all' }} options
 */
export default (options = {}) => ({
    mode: options.mode ?? 'none',

    /** Bound to the checkbox with `x-bind="control"`. */
    control: {
        [':checked']() {
            return this.mode === 'all';
        },
        ['x-effect']() {
            this.$el.indeterminate = this.mode === 'partial';
        },
        [':aria-checked']() {
            return this.mode === 'partial' ? 'mixed' : (this.mode === 'all' ? 'true' : 'false');
        },
    },
});
